import { render, staticRenderFns } from "./Legendar.vue?vue&type=template&id=079166f7"
import script from "./Legendar.vue?vue&type=script&lang=js"
export * from "./Legendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports